import React from "react";

const FIELDS = [
  ["first_name", "First name", "text", 30],
  ["last_name", "Last name", "text", 150],
  ["email", "Email address", "email"],
  ["address", "Account / mailing address", "text", 150],
  ["brokerage_name", "Brokerage / Company (optional)", "text", 255],
  ["mobilePhone", "Mobile phone (optional)", "tel", 30, "tel"],
  ["workPhone", "Work phone (optional)", "tel", 30, "work tel"],
];

export const profileToDraft = (profile = {}) => ({
  first_name: profile.first_name || "",
  last_name: profile.last_name || "",
  address: profile.address || "",
  brokerage_name: profile.brokerage_name || "",
  mobilePhone: (profile.phone_numbers || []).find(
    (phone) => phone.label.toLowerCase() === "mobile"
  )?.number || "",
  workPhone: (profile.phone_numbers || []).find(
    (phone) => phone.label.toLowerCase() === "work"
  )?.number || "",
});

export const draftToProfile = (draft) => ({
  first_name: draft.first_name,
  last_name: draft.last_name,
  address: draft.address,
  brokerage_name: draft.brokerage_name,
  phone_numbers: [
    { label: "Mobile", number: draft.mobilePhone.trim() },
    { label: "Work", number: draft.workPhone.trim() },
  ]
    .filter((phone) => phone.number)
    .map((phone, index) => ({ ...phone, is_primary: index === 0 })),
});

const ProfileDetailsFields = ({ draft, email, onChange, disabled, idPrefix = "profile" }) => (
  <div className="profile-details-fields">
    {FIELDS.map(([field, label, type, maxLength, autoComplete]) => (
      <div className="detail-box" key={field}>
        <label htmlFor={`${idPrefix}-${field}`}>{label}</label>
        <input
          id={`${idPrefix}-${field}`}
          type={type}
          className="profileInputBox"
          value={field === "email" ? email : draft[field]}
          disabled={field === "email" || disabled}
          maxLength={maxLength}
          autoComplete={autoComplete}
          onChange={(event) => onChange(field, event.target.value)}
        />
      </div>
    ))}
  </div>
);

export default ProfileDetailsFields;
